// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import parse, { HTMLReactParserOptions } from "html-react-parser";

const remove = ["html", "body"].join("|");
const empty = ["head"].map(x => `<${x}[^.]*\/${x}>`).join("|");

export default (html: string, options: HTMLReactParserOptions = parserOptions) => {
    const regexp = new RegExp(`<\/?(${remove})([^>]*)>|(${empty})|\r?\n|\r`, "gi");
    const _html = html.replace(regexp, "").trim();

    return parse(_html, options);
};
